import {
    useEffect,
    useState
} from "react";

import {
    useParams,
    useNavigate
} from "react-router-dom";

import API from "../../services/api";

function ViewPurchaseReturn() {

    const { id } =
        useParams();

    const navigate =
        useNavigate();

    const [purchaseReturn,
        setPurchaseReturn] =
        useState(null);

    const [items,
        setItems] =
        useState([]);

    useEffect(() => {

        loadPurchaseReturn();

    }, []);

    const loadPurchaseReturn =
        async () => {

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(

                        `/purchase-returns/${id}`,

                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`
                            }
                        }

                    );

                setPurchaseReturn(
                    res.data.purchaseReturn
                );

                setItems(
                    res.data.items || []
                );

            } catch (err) {

                console.log(err);

            }

        };

    const printInvoice =
        () => {

            window.print();

        };

    if (!purchaseReturn) {

        return (

            <div
                className="
                flex
                justify-center
                items-center
                h-[300px]
                text-xl
                "
            >
                Loading...
            </div>

        );

    }

    return (

        <div>

            {/* Header */}

            <div
                className="
                flex
                justify-between
                items-center
                flex-wrap
                gap-4
                mb-8
                no-print
                "
            >

                <div>

                    <h1
                        className="
                        text-4xl
                        font-bold
                        "
                    >
                        Purchase Return Invoice
                    </h1>

                    <p
                        className="
                        text-gray-400
                        mt-2
                        "
                    >
                        View Purchase Return Details
                    </p>

                </div>

                <div
                    className="
                    flex
                    gap-3
                    "
                >

                    <button
                        onClick={
                            printInvoice
                        }
                        className="
                        bg-blue-500
                        px-6
                        py-3
                        rounded-xl
                        "
                    >
                        Print
                    </button>

                    <button
                        onClick={() =>
                            navigate(
                                "/admin/purchase-returns"
                            )
                        }
                        className="
                        bg-yellow-500
                        text-black
                        px-6
                        py-3
                        rounded-xl
                        font-semibold
                        "
                    >
                        Back
                    </button>

                </div>

            </div>

            {/* Invoice */}

            <div
                className="
                bg-[#111]
                rounded-2xl
                p-8
                print:bg-white
                print:text-black
                "
            >
                {/* Header */}

                <div
                    className="
    flex
    justify-between
    items-start
    flex-wrap
    gap-8
    border-b
    border-yellow-500/20
    pb-8
    "
                >

                    {/* Company */}

                    <div>

                        <h2
                            className="
            text-3xl
            font-bold
            "
                        >
                            Billing Software
                        </h2>

                        <p className="mt-2">
                            Business Management ERP
                        </p>

                        <p className="mt-1">
                            support@billingsoftware.com
                        </p>

                        <p className="mt-1">
                            +91 9876543210
                        </p>

                    </div>

                    {/* Return Info */}

                    <div
                        className="
        text-right
        "
                    >

                        <h2
                            className="
            text-2xl
            font-bold
            text-orange-500
            "
                        >
                            PURCHASE RETURN
                        </h2>

                        <p className="mt-3">

                            <strong>
                                Return No :
                            </strong>

                            {" "}

                            {purchaseReturn.return_no}

                        </p>

                        <p className="mt-2">

                            <strong>
                                Date :
                            </strong>

                            {" "}

                            {purchaseReturn.return_date}

                        </p>

                        <p className="mt-2">

                            <strong>
                                Wallet :
                            </strong>

                            {" "}

                            {purchaseReturn.wallet_name}

                        </p>

                        {

                            purchaseReturn.purchase_id && (

                                <p className="mt-2">

                                    <strong>
                                        Purchase ID :
                                    </strong>

                                    {" "}

                                    #

                                    {purchaseReturn.purchase_id}

                                </p>

                            )

                        }

                    </div>

                </div>

                {/* Supplier */}

                <div
                    className="
    grid
    md:grid-cols-2
    gap-8
    mt-8
    mb-8
    "
                >

                    <div>

                        <h3
                            className="
            text-xl
            font-bold
            mb-4
            "
                        >
                            Supplier Details
                        </h3>

                        <p>

                            <strong>
                                Name :
                            </strong>

                            {" "}

                            {purchaseReturn.supplier_name}

                        </p>

                        <p className="mt-2">

                            <strong>
                                Phone :
                            </strong>

                            {" "}

                            {purchaseReturn.phone}

                        </p>

                        <p className="mt-2">

                            <strong>
                                Email :
                            </strong>

                            {" "}

                            {purchaseReturn.email || "-"}

                        </p>

                        <p className="mt-2">

                            <strong>
                                Address :
                            </strong>

                            {" "}

                            {purchaseReturn.address || "-"}

                        </p>

                    </div>

                    <div>

                        <h3
                            className="
            text-xl
            font-bold
            mb-4
            "
                        >
                            Return Details
                        </h3>

                        <p>

                            <strong>
                                Refund Wallet :
                            </strong>

                            {" "}

                            {purchaseReturn.wallet_name}

                        </p>

                        <p className="mt-2">

                            <strong>
                                Sub Total :
                            </strong>

                            {" "}

                            ₹

                            {Number(
                                purchaseReturn.subtotal
                            ).toFixed(2)}

                        </p>

                        <p className="mt-2">

                            <strong>
                                GST :
                            </strong>

                            {" "}

                            ₹

                            {Number(
                                purchaseReturn.gst_total
                            ).toFixed(2)}

                        </p>

                        <p className="mt-2">

                            <strong>
                                Grand Total :
                            </strong>

                            {" "}

                            ₹

                            {Number(
                                purchaseReturn.grand_total
                            ).toFixed(2)}

                        </p>

                    </div>

                </div>

                {

                    purchaseReturn.reason && (

                        <div
                            className="
            mb-8
            bg-orange-500/10
            border
            border-orange-500/20
            rounded-xl
            p-4
            "
                        >

                            <h3
                                className="
                font-semibold
                mb-2
                "
                            >
                                Return Reason
                            </h3>

                            <p>
                                {purchaseReturn.reason}
                            </p>

                        </div>

                    )

                }

                {/* Items */}

                <div
                    className="
    overflow-x-auto
    "
                >

                    <table
                        className="
    w-full
    "
                    >

                        <thead>

                            <tr
                                className="
    border-b
    border-yellow-500/20
    "
                            >

                                <th className="p-3 text-left">
                                    Product
                                </th>

                                <th className="p-3 text-left">
                                    Qty
                                </th>

                                <th className="p-3 text-left">
                                    Price
                                </th>

                                <th className="p-3 text-left">
                                    GST %
                                </th>

                                <th className="p-3 text-left">
                                    Amount
                                </th>

                            </tr>

                        </thead>

                        <tbody>
                            {items.length > 0 ? (

                                items.map(
                                    (
                                        item,
                                        index
                                    ) => (

                                        <tr
                                            key={index}
                                            className="
                border-b
                border-yellow-500/10
                "
                                        >

                                            <td className="p-3">
                                                {item.name}
                                            </td>

                                            <td className="p-3">
                                                {item.qty}
                                            </td>

                                            <td className="p-3">
                                                ₹
                                                {Number(
                                                    item.price
                                                ).toFixed(2)}
                                            </td>

                                            <td className="p-3">
                                                {item.gst_percent}%
                                            </td>

                                            <td
                                                className="
                    p-3
                    font-semibold
                    text-green-500
                    "
                                            >
                                                ₹
                                                {Number(
                                                    item.amount
                                                ).toFixed(2)}
                                            </td>

                                        </tr>

                                    )
                                )

                            ) : (

                                <tr>

                                    <td
                                        colSpan="5"
                                        className="
            p-8
            text-center
            text-gray-400
            "
                                    >
                                        No Products Found
                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>

                {/* Totals */}

                <div
                    className="
    mt-10
    flex
    justify-end
    "
                >

                    <div
                        className="
        w-full
        md:w-96
        bg-black
        print:bg-white
        border
        border-yellow-500/20
        rounded-2xl
        p-6
        "
                    >

                        <div
                            className="
            flex
            justify-between
            mb-4
            "
                        >

                            <span>
                                Sub Total
                            </span>

                            <span>
                                ₹
                                {Number(
                                    purchaseReturn.subtotal
                                ).toFixed(2)}
                            </span>

                        </div>

                        <div
                            className="
            flex
            justify-between
            mb-4
            "
                        >

                            <span>
                                GST
                            </span>

                            <span>
                                ₹
                                {Number(
                                    purchaseReturn.gst_total
                                ).toFixed(2)}
                            </span>

                        </div>

                        <div
                            className="
            flex
            justify-between
            border-t
            border-yellow-500/20
            pt-4
            text-2xl
            font-bold
            text-green-500
            "
                        >

                            <span>
                                Grand Total
                            </span>

                            <span>
                                ₹
                                {Number(
                                    purchaseReturn.grand_total
                                ).toFixed(2)}
                            </span>

                        </div>

                    </div>

                </div>

                {/* Footer */}

                <div
                    className="
    mt-16
    grid
    md:grid-cols-2
    gap-10
    "
                >

                    <div>

                        <p
                            className="
            text-sm
            text-gray-400
            print:text-gray-600
            "
                        >
                            Thank you for your business.
                        </p>

                        <p
                            className="
            mt-2
            text-sm
            text-gray-400
            print:text-gray-600
            "
                        >
                            This document confirms the
                            returned purchase and the
                            amount credited to your wallet.
                        </p>

                    </div>

                    <div
                        className="
        text-right
        "
                    >

                        <div
                            className="
            mt-10
            border-t
            border-gray-500
            inline-block
            pt-2
            w-56
            text-center
            "
                        >
                            Authorized Signature
                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default ViewPurchaseReturn;